<div class="flex align-items-center">
  <div class="w-full">
    <span [ngClass]="{ 'p-float-label': showFloatLabel }">
      <p-dropdown
        #dropdown
        [placeholder]="placeholder"
        [optionLabel]="labelProperty"
        [options]="options"
        [(ngModel)]="selectedEntry"
        (onChange)="onChange()"
        (keyup.esc)="emitEscape()"
        [style]="{ width: '100%' }"
        [appendTo]="appendTo"
        emptyMessage="Kein Eintrag vorhanden"
        dataKey="id"
      >
        <ng-template let-option pTemplate="item">
          <div
            class="flex align-items-center gap-2"
            [pTooltip]="!showTooltip || !option?.description ? null : option.description"
            tooltipPosition="top"
          >
            <i *ngIf="!!option?.icon" [class]="option.icon" [style.color]="option?.color"></i>
            <ng-container>{{ option.name }}</ng-container>
          </div>
        </ng-template>
      </p-dropdown>
      <label *ngIf="!!placeholder && showFloatLabel" [for]="dropdown.id">{{ placeholder }}</label>
    </span>
  </div>
  <button
    *ngIf="showDelete"
    pButton
    type="button"
    tabindex="-1"
    class="ml-1"
    (click)="onClickDelete()"
    icon="pi pi-times"
  ></button>
  <ng-content></ng-content>
</div>
